export interface CoachSubFunctionOption {
  group: string;
  label: string;
  slug: string;
}

export const COACH_SUB_FUNCTION_GROUPS = [
  {
    group: 'Product',
    options: [
      {
        label: 'Growth PM',
        slug: 'growth_pm',
      },
      {
        label: 'Infrastructure PM',
        slug: 'infrastructure_pm',
      },
      {
        label: 'AI / Data Product',
        slug: 'ai_data_product',
      },
      {
        label: 'Product Operations & Strategy',
        slug: 'product_operations_strategy',
      },
    ],
  },
  {
    group: 'Ops & Strategy',
    options: [
      {
        label: 'Business Operations',
        slug: 'business_operations',
      },
      {
        label: 'Revenue / GTM Operations',
        slug: 'revenue_gtm_operations',
      },
      {
        label: 'Program & Project Management',
        slug: 'program_project_management',
      },
      {
        label: 'Corporate Strategy',
        slug: 'corporate_strategy',
      },
      {
        label: 'Chief of Staff (CoS)',
        slug: 'chief_of_staff_cos',
      },
      {
        label: 'Healthcare/Clinician Ops',
        slug: 'healthcare_clinician_ops',
      },
    ],
  },
  {
    group: 'People Ops',
    options: [
      {
        label: 'Talent Acquisition / Recruiting',
        slug: 'talent_acquisition_recruiting',
      },
      {
        label: 'HR Business Partnership',
        slug: 'hr_business_partnership',
      },
      {
        label: 'Learning, Leadership & Organizational Development',
        slug: 'learning_leadership_organizational_development',
      },
      {
        label: 'Compensation, Benefits & People Operations / Total Rewards',
        slug: 'compensation_benefits_people_operations_total_rewards',
      },
      {
        label: 'People Analytics & Workforce Planning',
        slug: 'people_analytics_workforce_planning',
      },
      {
        label: 'HR Tech',
        slug: 'hr_tech',
      },
    ],
  },
  {
    group: 'Sales',
    options: [
      {
        label: 'SMB / Mid-Market Sales',
        slug: 'smb_mid_market_sales',
      },
      {
        label: 'Enterprise Sales',
        slug: 'enterprise_sales',
      },
      {
        label: 'Account Executive',
        slug: 'account_executive',
      },
      {
        label: 'Sales Engineering / Solutions Consulting',
        slug: 'sales_engineering_solutions_consulting',
      },
      {
        label: 'Account Management / Partner Success',
        slug: 'account_management_partner_success',
      },
      {
        label: 'Sales Operations & Enablement',
        slug: 'sales_operations_enablement',
      },
      {
        label: 'Revenue Operations',
        slug: 'revenue_operations',
      },
      {
        label: 'Partnerships',
        slug: 'partnerships',
      },
      {
        label: 'Business Development',
        slug: 'business_development',
      },
      {
        label: 'BDR',
        slug: 'bdr',
      },
    ],
  },
  {
    group: 'Data Science',
    options: [
      {
        label: 'Product & Growth Analytics',
        slug: 'product_growth_analytics',
      },
      {
        label: 'Machine Learning / AI',
        slug: 'machine_learning_ai',
      },
      {
        label: 'Business Intelligence & Decision Science',
        slug: 'business_intelligence_decision_science',
      },
      {
        label: 'AI Evaluation, Safety & Governance',
        slug: 'ai_evaluation_safety_governance',
      },
    ],
  },
  {
    group: 'Engineering',
    options: [
      {
        label: 'Frontend Engineering',
        slug: 'frontend_engineering',
      },
      {
        label: 'Backend Engineering',
        slug: 'backend_engineering',
      },
      {
        label: 'Full Stack Engineering',
        slug: 'full_stack_engineering',
      },
      {
        label: 'Infrastructure / Cloud / Platform Engineering',
        slug: 'infrastructure_cloud_platform_engineering',
      },
      {
        label: 'DevOps / SRE / Reliability Engineering',
        slug: 'devops_sre_reliability_engineering',
      },
      {
        label: 'Security Engineering',
        slug: 'security_engineering',
      },
      {
        label: 'Data Engineering',
        slug: 'data_engineering',
      },
      {
        label: 'ML / AI Engineering',
        slug: 'ml_ai_engineering',
      },
      {
        label: 'Research Engineering',
        slug: 'research_engineering',
      },
      {
        label: 'Developer Productivity & Internal Tooling',
        slug: 'developer_productivity_internal_tooling',
      },
      {
        label: 'Solutions / Forward Deployed / Customer Engineering',
        slug: 'solutions_forward_deployed_customer_engineering',
      },
      {
        label: 'Product Engineering',
        slug: 'product_engineering',
      },
      {
        label: 'Capacity Engineering',
        slug: 'capacity_engineering',
      },
      {
        label: 'Hardware Engineering',
        slug: 'hardware_engineering',
      },
      {
        label: 'Technical Program Management (TPM)',
        slug: 'technical_program_management_tpm',
      },
    ],
  },
  {
    group: 'Marketing & Communications',
    options: [
      {
        label: 'Growth & Performance Marketing',
        slug: 'growth_performance_marketing',
      },
      {
        label: 'Product Marketing',
        slug: 'product_marketing',
      },
      {
        label: 'Brand Marketing',
        slug: 'brand_marketing',
      },
      {
        label: 'Lifecycle / CRM Marketing',
        slug: 'lifecycle_crm_marketing',
      },
      {
        label: 'Marketing Operations & Analytics',
        slug: 'marketing_operations_analytics',
      },
      {
        label: 'Content Marketing',
        slug: 'content_marketing',
      },
      {
        label: 'Communications',
        slug: 'communications',
      },
    ],
  },
  {
    group: 'Customer Success',
    options: [
      {
        label: 'Customer Success Management',
        slug: 'customer_success_management',
      },
      {
        label: 'Technical Account Management / Solutions Architecture',
        slug: 'technical_account_management_solutions_architecture',
      },
      {
        label: 'Onboarding & Implementation',
        slug: 'onboarding_implementation',
      },
      {
        label: 'Technical Support & Escalation',
        slug: 'technical_support_escalation',
      },
      {
        label: 'Renewals, Expansion & Customer Operations',
        slug: 'renewals_expansion_customer_operations',
      },
    ],
  },
  {
    group: 'Design',
    options: [
      {
        label: 'Product Design',
        slug: 'product_design',
      },
      {
        label: 'UX Design',
        slug: 'ux_design',
      },
      {
        label: 'UX Research',
        slug: 'ux_research',
      },
      {
        label: 'Design Systems & DesignOps',
        slug: 'design_systems_designops',
      },
      {
        label: 'Brand & Creative Design',
        slug: 'brand_creative_design',
      },
      {
        label: 'AI / Conversational Experience Design',
        slug: 'ai_conversational_experience_design',
      },
    ],
  },
  {
    group: 'Finance',
    options: [
      {
        label: 'FP&A & Strategic Finance',
        slug: 'fp_a_strategic_finance',
      },
      {
        label: 'Accounting, Tax & Audit',
        slug: 'accounting_tax_audit',
      },
      {
        label: 'SaaS / Cloud / Infrastructure Finance (FinOps)',
        slug: 'saas_cloud_infrastructure_finance_finops',
      },
      {
        label: 'M&A and Corp Dev',
        slug: 'm_a_and_corp_dev',
      },
      {
        label: 'Risk',
        slug: 'risk',
      },
      {
        label: 'Investor Relations & Corporate Development',
        slug: 'investor_relations_corporate_development',
      },
      {
        label: 'GTM Finance',
        slug: 'gtm_finance',
      },
    ],
  },
  {
    group: 'Legal',
    options: [
      {
        label: 'Commercial & Product Counsel',
        slug: 'commercial_product_counsel',
      },
      {
        label: 'Privacy, Security & Compliance',
        slug: 'privacy_security_compliance',
      },
      {
        label: 'Corporate & Employment Legal',
        slug: 'corporate_employment_legal',
      },
      {
        label: 'IP, Licensing & Open Source',
        slug: 'ip_licensing_open_source',
      },
      {
        label: 'AI Governance & Regulatory Affairs',
        slug: 'ai_governance_regulatory_affairs',
      },
      {
        label: 'Legal Operations',
        slug: 'legal_operations',
      },
      {
        label: 'Policy & Risk',
        slug: 'policy_risk',
      },
    ],
  },
  {
    group: 'Research',
    options: [
      {
        label: 'Applied AI / Technical Research',
        slug: 'applied_ai_technical_research',
      },
      {
        label: 'Eval Research',
        slug: 'eval_research',
      },
      {
        label: 'UX & Behavioral Research',
        slug: 'ux_behavioral_research',
      },
      {
        label: 'Market & Competitive Intelligence',
        slug: 'market_competitive_intelligence',
      },
      {
        label: 'Research Operations & Evaluation Systems',
        slug: 'research_operations_evaluation_systems',
      },
    ],
  },
  {
    group: 'Developer Relations (DevRel)',
    options: [
      {
        label: 'Developer Relations',
        slug: 'developer_relations',
      },
      {
        label: 'Developer Advocacy',
        slug: 'developer_advocacy',
      },
      {
        label: 'Technical Content & Education',
        slug: 'technical_content_education',
      },
      {
        label: 'Community Programs',
        slug: 'community_programs',
      },
      {
        label: 'SDK / Documentation Programs',
        slug: 'sdk_documentation_programs',
      },
      {
        label: 'Ecosystem Partnerships',
        slug: 'ecosystem_partnerships',
      },
    ],
  },
  {
    group: 'Trust & Safety',
    options: [
      {
        label: 'Trust & Safety',
        slug: 'trust_safety',
      },
      {
        label: 'Fraud & Abuse Prevention',
        slug: 'fraud_abuse_prevention',
      },
      {
        label: 'Content Moderation & Policy',
        slug: 'content_moderation_policy',
      },
      {
        label: 'Platform Integrity',
        slug: 'platform_integrity',
      },
      {
        label: 'Risk Operations',
        slug: 'risk_operations',
      },
      {
        label: 'AI Safety & Governance',
        slug: 'ai_safety_governance',
      },
    ],
  },
  {
    group: 'IT / Enterprise Technology',
    options: [
      {
        label: 'Internal IT & Support',
        slug: 'internal_it_support',
      },
      {
        label: 'Identity & Access Management',
        slug: 'identity_access_management',
      },
      {
        label: 'Enterprise Systems & SaaSOps',
        slug: 'enterprise_systems_saasops',
      },
      {
        label: 'Endpoint & Device Security',
        slug: 'endpoint_device_security',
      },
      {
        label: 'Productivity & Collaboration Infrastructure',
        slug: 'productivity_collaboration_infrastructure',
      },
    ],
  },
] as const;

export const COACH_SUB_FUNCTION_OPTIONS: CoachSubFunctionOption[] =
  COACH_SUB_FUNCTION_GROUPS.flatMap(({ group, options }) =>
    options.map((option) => ({ ...option, group })),
  );

export const COACH_SUB_FUNCTION_SLUGS: Set<string> = new Set(
  COACH_SUB_FUNCTION_OPTIONS.map(({ slug }) => slug),
);

export const COACH_SUB_FUNCTION_LABEL_BY_SLUG = Object.fromEntries(
  COACH_SUB_FUNCTION_OPTIONS.map(({ label, slug }) => [slug, label]),
) as Record<string, string>;

export const isCoachSubFunctionSlug = (slug: string): boolean =>
  COACH_SUB_FUNCTION_SLUGS.has(slug);

export const coachSubFunctionLabel = (slug: string): string =>
  COACH_SUB_FUNCTION_LABEL_BY_SLUG[slug] ??
  slug
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
